import { MetodosPagamento } from 'src/tipos'

export const SELECT_METODOSPAGAMENTO = Object.keys(MetodosPagamento)
  .filter(x => x !== MetodosPagamento.Isencao)
  .map(item => ({
    id: item,
    texto: MetodosPagamento[item as keyof typeof MetodosPagamento]
  }))
